// import {
//     Box,
//     Table,
//     TableBody,
//     TableCell,
//     TableHead,
//     TableRow,
//     TextField,
//     useTheme,
// } from "@material-ui/core";
// import { ChangeEvent, Dispatch, SetStateAction } from "react";
// import { currencyFormatter } from "../../constants";
// import { PaymentHeadResponse } from "./CreatePayment/CreatePayment";

// type Props = {
//     heads: PaymentHeadResponse[];
//     setHeads: Dispatch<SetStateAction<PaymentHeadResponse[]>>;
// };

// const SelectedHeadsNAmounts = ({ heads, setHeads }: Props) => {
//     console.log("it hits");
//     const theme = useTheme();

//     //
//     function handleChange(
//         event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
//         currHead: PaymentHeadResponse
//     ) {
//         setHeads((currHeads) => {
//             return [
//                 ...currHeads.map((head) =>
//                     head.id === currHead.id
//                         ? { ...head, amount: +event.target.value }
//                         : head
//                 ),
//             ];
//         });
//     }

//     return (
//         <Box
//             border={`1px solid ${theme.palette.grey[600]}`}
//             borderRadius={theme.shape.borderRadius}
//         >
//             <Table size="small">
//                 <TableHead>
//                     <TableCell>SR. No</TableCell>
//                     <TableCell>Heads</TableCell>
//                     <TableCell>Amounts</TableCell>
//                 </TableHead>
//                 <TableBody>
//                     {heads.map((head, index) => (
//                         <TableRow key={head.id}>
//                             <TableCell>{index + 1}</TableCell>

//                             <TableCell>{head.name}</TableCell>

//                             <TableCell>
//                                 {head.isAmountEditable ? (
//                                     <TextField
//                                         // variant="outlined"
//                                         size="small"
//                                         value={head.amount}
//                                         type="number"
//                                         onChange={(event) =>
//                                             handleChange(event, head)
//                                         }
//                                         inputProps={{ min: 0 }}
//                                     />
//                                 ) : (
//                                     currencyFormatter(head.amount)
//                                 )}
//                             </TableCell>
//                         </TableRow>
//                     ))}
//                 </TableBody>
//             </Table>
//         </Box>
//     );
// };

// export default SelectedHeadsNAmounts;

import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TextField,
    makeStyles,
    useTheme,
} from "@material-ui/core";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { currencyFormatter } from "../../constants";
import { PaymentHeadResponse } from "./CreatePayment/CreatePayment";

const useStyles = makeStyles({
    table: {
        tableLayout: "fixed",
        width: "100%",
    },
    srColumn: {
        width: "10%",
    },
    headColumn: {
        width: "35%",
    },
    amountColumn: {
        width: "55%",
    },
});

type Props = {
    heads: PaymentHeadResponse[];
    setHeads: Dispatch<SetStateAction<PaymentHeadResponse[]>>;
    collections?: any;
    collecteeId?: any;
    setCollections?: any;
};

const SelectedHeadsNAmounts = ({
    heads,
    setHeads,
    collections,
    collecteeId,
    setCollections,
}: Props) => {
    const theme = useTheme();
    const classes = useStyles();

    function handleChange(
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
        currHead: PaymentHeadResponse
    ) {
        const rawValue = event.target.value;
        if (rawValue !== "" && !/^\d*\.?\d*$/.test(rawValue)) {
            return;
        }

        const amount =
            rawValue === "" ? null : Number.parseFloat(rawValue);

        setHeads((currHeads) => {
            const updatedHeads = currHeads.map((head) =>
                head.id === currHead.id ? { ...head, amount } : head
            );

            if (collecteeId) {
                setCollections((prevCollections: any) => ({
                    ...prevCollections,
                    [collecteeId]: {
                        ...prevCollections[collecteeId],
                        heads: updatedHeads,
                    },
                }));
            }

            return updatedHeads;
        });
    }

    const amountField = (head: PaymentHeadResponse) => (
        <TextField
            variant="outlined"
            fullWidth
            label="Amount"
            value={
                head.isAmountEditable
                    ? head.amount ?? ""
                    : head.amount ?? 0
            }
            type="text"
            disabled={!head.isAmountEditable}
            onChange={(event) => handleChange(event, head)}
            inputProps={{ inputMode: "decimal" }}
        />
    );

    return (
        <Box
            border={`1px solid ${theme.palette.grey[600]}`}
            borderRadius={theme.shape.borderRadius}
        >
            {!collecteeId ? (
                <Table size="small" className={classes.table}>
                    <TableHead>
                        <TableCell className={classes.srColumn}>
                            SR. No
                        </TableCell>
                        <TableCell className={classes.headColumn}>
                            Heads
                        </TableCell>
                        <TableCell className={classes.amountColumn}>
                            Amounts
                        </TableCell>
                    </TableHead>
                    <TableBody>
                        {heads.map((head, index) => (
                            <TableRow key={head.id}>
                                <TableCell className={classes.srColumn}>
                                    {index + 1}
                                </TableCell>
                                <TableCell className={classes.headColumn}>
                                    {head.name}
                                </TableCell>
                                <TableCell className={classes.amountColumn}>
                                    {amountField(head)}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            ) : (
                heads.map((head: any) =>
                    head.isAmountEditable
                        ? amountField(head)
                        : currencyFormatter(head.amount ?? 0)
                )
            )}
        </Box>
    );
};

export default SelectedHeadsNAmounts;
